module.exports = __webpack_public_path__ + "img/15f4805.jpg";